<template>
  <section>
    <div class="mx-2" v-if="group === 'splatter' || group === 'marble'">
      <h2>What colours would you like?</h2>
      <p class="text-sm text-gray-600 mb-2">You can choose up to three</p>
      <input type="text" class="input text-center mb-1" maxlength="15" placeholder="Colour choice 1" v-model="c1" />
      <input type="text" class="input text-center mb-1" maxlength="15" placeholder="Colour choice 2" v-model="c2" />
      <input type="text" class="input text-center" maxlength="15" placeholder="Colour choice 3" v-model="c3" />
    </div>
    <div class="mx-2" v-else-if="group === 'drip'">
      <h2>What colour of drip would you like?</h2>
      <p class="text-sm text-gray-600 mb-2">We will match the top accordingly</p>
      <div class="buttons flex-wrap">
        <standard-button 
          v-for="(item,i) in filteredColours" :key="i"
          @click="setC1(item.name)"
          :active="c1 == item.name"
        >
          {{item.name}}
        </standard-button>
      </div>
      <div class="px-2">
        <input type="text" class="input text-center mb-1" maxlength="15" placeholder="Other" v-model="c2" />
      </div>
    </div>
    <div class="mx-2" v-else-if="group === 'abstract'">
      <h2>What colour would you like?</h2>
      <input type="text" class="input text-center mb-1" maxlength="15" placeholder="Colour choice 1" v-model="c1" />
      <input type="text" class="input text-center mb-1" maxlength="15" placeholder="Colour choice 2" v-model="c2" />
      <h2 class="mt-4">What colour of gold leaf would you like?</h2>
      <div class="buttons flex-wrap">
        <standard-button 
          v-for="(item,i) in filteredLeafColours" :key="i"
          @click="setC3(item.name)"
          :active="c3 == item.name"
        >
          {{item.name}}
        </standard-button>
      </div>
    </div>
    <div class="mx-2" v-else>
      <h2>What colour would you like?</h2>
      <div class="buttons flex-wrap">
        <standard-button 
          v-for="(item,i) in filteredColours" :key="i"
          @click="setColour(item.name)"
          :active="value == item.name"
        >
          {{item.name}}
        </standard-button>
      </div>
    

      <p class="text-sm text-gray-700 mt-2">Don't see the colour you are after?<br/>Add it to the "Any additional instructions" section during checkout</p>
      
    </div>
  </section>
</template>


<script>
import StandardButton from './StandardButton'
import { compact, map } from 'lodash'
export default {
  model: {
    value: 'value',
    event: 'input'
  },
  props: {
    value: {},
    group: {},
  },
  components: {
    StandardButton
  },
  data() {
    return {
      c1: undefined,
      c2: undefined,
      c3: undefined
    }
  },
  watch: {
    c1() {
      this.$emit('input', this.colours)
    },
    c2() {
      this.$emit('input', this.colours)
    },
    c3() {
      this.$emit('input', this.colours)
    }
  },
  mounted() {
    const c = this.value.split("|")
    this.c1 = c[0].trim()
    this.c2 = c[1].trim()
    this.c3 = c[2].trim()
  },
  methods: {
    setColour(id) {
      this.$emit('input',id)
      this.$scrollTo(document.getElementById('flavours'), 1000, { offset: -50 })
    },
    setC1(c) {
      this.c1 = c
    },
    setC2(c) {
      this.c2 = c
    },
    setC3(c) {
      this.c3 = c
    }
  },
  computed: {
    filteredColours() {
      return this.$root.$data.colours[this.group]
    },
    filteredLeafColours() {
      return this.$root.$data.colours[`${this.group}Leaf`]
    },
    colours() {
      return map(compact([this.c1,this.c2,this.c3]), o => o.replace("|","")).join(" | ")
    }
  }
}
</script>
